/* stylelint-disable */
.show-button {
  margin: 2px 0;
}

:host(.light) .show-button {
  margin: 10px 0;
}

@media screen and (min-width: 980px) {
  .description-text {
    height: auto;
  }

  :host(.light) .description-text {
    color: #ffffff;
  }
}

.description-text--safari {
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1rem;
  line-height: 1.5rem;
  margin: 16px 0 0;
}

:host(.category) .description-text--safari {
  margin: 24px 0 0;
}

.text-container.expanded {
  -webkit-line-clamp: unset;
}

.text-container {
  display: block;
  margin: 16px 0 0;
  font-size: 1rem;
  line-height: 1.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.text-container a {
  display: inline-block;
  border-radius: var(--qds-focus-border-radius);
  box-sizing: border-box;
  text-decoration: underline;
  color: var(--qds-theme-link-standard-default);
}

.text-container a:visited {
  color: var(--qds-theme-link-standard-visited);
}

.text-container a:hover {
  color: var(--qds-theme-link-standard-hover);
}

.text-container a:active {
  color: var(--qds-theme-link-standard-pressed);
}

.text-container a:visited:hover {
  color: var(--qds-theme-link-standard-visited-hover);
}

.text-container a:visited:active {
  color: var(--qds-theme-link-standard-visited-pressed);
}

.text-container a[rel~=external] > .qds-external {
  display: inline-block;
}

.text-container a:focus-visible {
  outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
}

.text-container a[aria-disabled=true] {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

.text-container p {
  margin: 0;
}

@media screen and (min-width: 980px) {
  .text-container {
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

:host(.category) .text-container {
  margin: 24px 0 0;
}

@media screen and (min-width: 980px) {
  .text-container--banner {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

.blurred-text {
  z-index: 1;
  position: relative;
}

:host(:not([dir="rtl"])) .blurred-text {
  box-shadow: white 1px -3px 11px 8px;
}

:host([dir="rtl"]) .blurred-text {
  box-shadow: white -1px -3px 11px 8px;
}

.font-m {
  font-size: 14px;
  line-height: 1.4285714286;
}

.description__content {
  color: #626469;
}

@media screen and (max-width: 979px) {
  .description__content {
    margin-bottom: 12px;
  }
}

@media screen and (min-width: 980px) {
  .description__content {
    width: 780px;
  }
}

.blurred-text {
  box-shadow: white 0px -19px 9px 11px;
  z-index: 1;
  position: relative;
}

.pdp-long-desc {
  text-align: justify;
  margin: unset;
}

.pdp-long-desc > .pes-ellipsis {
  text-align: justify;
}